// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const additionalRepair = claim =>
    dispatch => {

        dispatch({
            data: claim,
            type: actions.ADD_CLAIM_INCENTIVE_ADDITIONAL_REPAIR
        });

        dispatch(routerActions.push('/claims/incentive/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/additional-repair.js